import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminContestEntriesContestEntryRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ contest_entry_id }) {
    const { content } = await this.store.request(
      findRecord('contest-entry', contest_entry_id),
    );

    return content.data;
  }

  async afterModel(model) {
    if (!this.breadcrumb.hasRoutes) {
      this.breadcrumb.registerDetailRoute(await model.contest);
    }
    this.breadcrumb.registerDetailRoute(model, {
      recordExplorerModelName: 'contest',
    });
  }
}
